(ns hai.library.routes
  (:require
   [hai.ui.components :as c]
   [hai.web-app.layout :as layout]
   [hai.web-app.routing :as routing]))

(defn page
  [_]
  [layout/page
   [layout/title-bar
    [c/Heading "Library 🚧"]]
   [:div "Coming soon!"]])

(defn routes []
  [["/library" {:name :library/list
                ::routing/window-title "Library"
                :view page}]])